import {
  AddRepeatedFieldAction,
  GenericFormData,
  RemoveRepeatedFieldAction,
  ResetFormAction,
  SetRepeatedFieldAction,
  SimpleFieldUpdateAction,
  UpdateRepeatedFieldAction,
} from './types.js';

export function fieldUpdate<
  FormData extends GenericFormData,
  Field extends keyof FormData = keyof FormData,
>(field: Field, value: FormData[Field]): SimpleFieldUpdateAction<FormData> {
  return {
    type: 'simpleUpdate',
    payload: { field, value },
  };
}

export function addRepeated<
  FormData extends GenericFormData,
  Field extends keyof FormData = keyof FormData,
>(field: Field, value: FormData[Field][number]): AddRepeatedFieldAction<FormData> {
  return {
    type: 'addRepeated',
    payload: { field, value },
  };
}

export function removeRepeated<
  FormData extends GenericFormData,
  Field extends keyof FormData = keyof FormData,
>(field: Field, index: number): RemoveRepeatedFieldAction<FormData> {
  return {
    type: 'removeRepeated',
    payload: { field, index },
  };
}

export function setRepeated<
  FormData extends GenericFormData,
  Field extends keyof FormData = keyof FormData,
>(field: Field, index: number, value: FormData[Field][number]): SetRepeatedFieldAction<FormData> {
  return {
    type: 'setRepeated',
    payload: { field, index, value },
  };
}

export function updateRepeated<
  FormData extends GenericFormData,
  Field extends keyof FormData = keyof FormData,
  SubField extends keyof FormData[Field][number] = keyof FormData[Field][number],
>(
  field: Field,
  index: number,
  subfield: SubField,
  value: FormData[Field][number][SubField],
): UpdateRepeatedFieldAction<FormData> {
  return {
    type: 'updateRepeated',
    payload: { field, index, update: { field: subfield, value } },
  };
}

export function resetForm<FormData extends GenericFormData>(
  data: FormData,
): ResetFormAction<FormData> {
  return {
    type: 'reset',
    payload: data,
  };
}
